'use client';

type NotifyOptions = {
  icon: 'success' | 'error' | 'warning' | 'info' | 'question';
  title: string;
  text: string;
  confirmButtonColor?: string;
};

export async function notify(options: NotifyOptions) {
  try {
    const Swal = (await import('sweetalert2')).default;
    await Swal.fire({
      icon: options.icon,
      title: options.title,
      text: options.text,
      confirmButtonColor: options.confirmButtonColor,
    });
    return;
  } catch (error) {
    const message = `${options.title}\n\n${options.text}`;

    if (typeof window !== 'undefined') {
      window.alert(message);
    } else {
      console[options.icon === 'error' ? 'error' : 'log'](message);
    }
  }
}
